/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./gad7QuestionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IaptFeelingNervousAnxiousOrOnEdge,
        questionText: "Feeling nervous, anxious or on edge",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptNotBeingAbleToStopOrControlWorrying,
        questionText: "Not being able to stop or control worrying",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptWorryingTooMuchAboutDifferentThings,
        questionText: "Worrying too much about different things",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleRelaxing,
        questionText: "Trouble relaxing",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptBeingSoRestlessThatItIsHardToSitStill,
        questionText: "Being so restless that it is hard to sit still",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptBecomingEasilyAnnoyedOrIrritable,
        questionText: "Becoming easily annoyed or irritable",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingAfraidAsIfSomethingAwfulMightHappen,
        questionText: "Feeling afraid as if something awful might happen",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
